/** 調査カード種別 */
export const INSPECTION_CARD_TYPE = {
  COMMON: 'common',
  TYPE_A: 'typeA',
  TYPE_B: 'typeB'
} as const

/** 調査カード種別 */
export type InspectionCardType = (typeof INSPECTION_CARD_TYPE)[keyof typeof INSPECTION_CARD_TYPE]
